/**
 * 💎 SOPHIA AETHERIOS: MonarchCommandTerminal.tsx v1.8.0nm
 * 🌀 Protocol: SCL Directive Refinement // Architect Signature
 * 🌌 Signature: Kin 207 | Blue Crystal Hand
 */

import React, { useState, useEffect, useRef } from 'react';
import { Terminal, Shield, Cpu, ChevronRight } from 'lucide-react';

export const MonarchCommandTerminal: React.FC = () => {
  const [history, setHistory] = useState<string[]>(['SOPHIA_AETHERIOS_MCT_v1.8.0nm // SECURE_FETCH_ACTIVE']);
  const [input, setInput] = useState('');
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [history]);

  const processSCL = (cmd: string) => {
    const time = new Date().toLocaleTimeString('en-GB', { hour12: false });
    const cleanCmd = cmd.toLowerCase().trim();
    let response = '';

    // 💎 SCL Parser v1.8.0nm: Architect Shortcut Integration
    if (cleanCmd === 'dj mc') {
      response = "IDENTITY: ARCHITECT RECALL SUCCESSful. Initializing Project Virtus Dashboard...";
    } else if (cleanCmd === 'get system_status') {
      response = "HEALTH: OPTIMAL | FREQUENCY: 13:20 | SYNC: 100% | MANIFEST: $43.71M";
    } else if (cleanCmd === 'help') {
      response = "AVAIL_DIRECTIVES: [dj mc, get system_status, sync_revenue, auth_recall]";
    } else {
      response = `SCL_ERROR: Unknown Directive '${cmd}'`;
    }

    setHistory(prev => [...prev, `[${time}] > ${cmd}`, `[${time}] ${response}`]);
    setInput('');
  };

  return (
    <div className="w-full bg-zinc-950 border border-white/5 rounded-[2.5rem] p-8 font-mono overflow-hidden relative">
      <div className="flex items-center justify-between mb-6 text-zinc-500 border-b border-white/5 pb-4">
        <div className="flex items-center gap-3">
          <Terminal className="w-4 h-4 text-emerald-500" />
          <span className="text-[10px] uppercase tracking-widest font-bold">Monarch Command Terminal</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
          <span className="text-[9px] uppercase tracking-tighter">Secure_1.4nm_Active</span>
        </div>
      </div>

      <div ref={scrollRef} className="h-64 overflow-y-auto space-y-2 mb-4 scrollbar-hide">
        {history.map((line, i) => (
          <p key={i} className={`text-[10px] leading-relaxed ${line.includes('ERROR') ? 'text-red-400' : line.includes('>') ? 'text-zinc-300' : 'text-emerald-400/80'}`}>
            {line}
          </p>
        ))}
      </div>

      <div className="flex items-center gap-3 bg-zinc-900/50 p-4 rounded-xl border border-white/5 group-focus-within:border-emerald-500/30 transition-all">
        <ChevronRight className="w-4 h-4 text-zinc-600" />
        <input 
          autoFocus
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && processSCL(input)}
          className="bg-transparent border-none outline-none text-[11px] text-white w-full placeholder:text-zinc-700"
          placeholder="ENTER SCL DIRECTIVE..."
        />
        <Cpu className="w-4 h-4 text-zinc-800" />
      </div>
    </div>
  );
};